import $ from 'jquery';

const defaults = {
  click: '.dropdown-clickable',
  expand: '.dropdown-list',
  single: false,
};

function DropdownBuilder(element, options) {
  this.element = element;
  this.$element = $(element);
  this.settings = { ...defaults, ...options };
  this.init();
}

DropdownBuilder.prototype = {
  init() {
    const $clickable = this.$element.find(this.settings.click);
    const $expandable = this.$element.find(this.settings.expand);
    $clickable.bind('click', (event) => {
      event.preventDefault();
      if ($clickable.is('.expanded')) {
        $clickable.removeClass('expanded');
        $expandable.slideUp('fast');
      } else {
        if (this.settings.single) {
          this.$element
            .siblings()
            .find(this.settings.click)
            .removeClass('expanded')
            .find(this.settings.expand)
            .slideUp('fast');
        }
        $clickable.addClass('expanded');
        $expandable.slideDown('fast');
      }
    });
  },
};

export default DropdownBuilder;



// WEBPACK FOOTER //
// ./DropdownBuilder.js